module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/mount-sinai-dd88ef72ba9599d823633e69a8c3319b.png";